module.exports = __webpack_public_path__ + "static/media/search-gray.c0e5d641.svg";